import React, { useEffect,useState } from "react";
import "./OrderCompletedNew.css";
import { Link } from "react-router-dom";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { useSearchParams } from "react-router-dom";

const OrderCompletedNew = () => {
  const [searchParams] = useSearchParams();
  const order_number = searchParams.get("order_number");

	const [loading,setLoading] = useState(true);

  const [course, setCourse] = useState([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.title = `Order Completed New | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ordercomplete'

    localStorage.removeItem("cartItems");
    
    /* Start get order data */
    let formData = new FormData(); 
    formData.append('order_number', order_number);
    API.post('get_course_for_web',formData)
      .then(response => {
        setLoading(false);
      if(response.data.status === false){
        
      }else{
         setCourse(response.data.data);
      }                  
    }).catch(error => {
       
    });  
   /* End get order data */
  }, [order_number]);

  return (
    <>
      <div className="container py-5 vh-100 d-flex align-items-center justify-content-center">
        <div className="row justify-content-center">
         <div className="col-md-8"> 
        <div className="comple">
          <div className="row">
            <div className="col-md-12 order-first">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-right.png'}
                alt="modal-right"
                className="img-fluid"
              />
              <h3>Order completed</h3>
              <p>
                <b>Thank you for your purchase - a confirmation email is on its way to your inbox! You will have detailed instructions to access the Masterclass in your email.</b>
              </p>
            </div>
          </div>

          {course && course.map((val,index) => {
          return(
            <div className="row d-flex align-items-center uio">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 succ-box-course-name">
                <h3>{val.course_name}</h3>
                
              </div>
              {/*<div className="col-md-6 col-sm-6 col-6 text-end p-0 links">
                <div className="orak">
                <p>€{val.price}</p>
                </div>
                
              </div>*/}
            </div>
          )
        })}
          <div className="row d-flex align-items-center text-center text-md-start apple"> 
            <div className="col-md-12 col-lg-6 p-0 mb-3 mb-lg-0">
              <h2> Get the app </h2>
            </div>
            <div className="col-md-12 col-lg-6 p-0 text-center text-lg-end">
              <Link to="https://apps.apple.com/us/app/your-friend-my-friend/id6748553590" target="_blank">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-app.png'}
                  alt="App Store"
                  className="me-2"
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.yourfriend.myfriend" target="_blank">
                <img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-google.png'} alt="Google Play" />
              </Link>
            </div>
            <div className="text-center mt-5">
              <Link className="btn brow-bu text-decoration-none" to="/dating-masterclass">BACK TO YFMF</Link>
            </div>
          </div>
        </div>
        </div>
        </div>
      </div>
      {loading && (
     <div className="loadingClass">
      <img src={loader} alt="loader"/>
    </div>
     )}
    </>
  );
};

export default OrderCompletedNew;
